import { HostListener, Injectable } from '@angular/core';
import { TEMPLATE_WIDTH_CHANGE } from '@shared-libs/constants';
import { Template } from '@shared-libs/enums';

@Injectable()
export abstract class BaseComponent {
	public template: Template;

	constructor() {
		this.setTemplate(window.innerWidth);
	}

	@HostListener('window:resize', ['$event'])
	public onResize(): void {
		this.setTemplate(window.innerWidth);
	}

	public setTemplate(width: number): void {
		// op web wordt er de keuze gemaakt, als het native in de app zit moet het altijd mobile zijn onafhankelijk van de viewport
		if (width >= TEMPLATE_WIDTH_CHANGE) {
			this.template = Template.desktop;
		} else this.template = Template.mobile;
	}
}
